export const setupIntent = {
  method: 'POST',
  url: '/api/stripe/setup_intents/v1'
};
